import { useEffect, useState } from "react";
import Button from "antd/es/button";
import Row from "antd/es/row";
import Col from "antd/es/col";
import Card from "antd/es/card";
import Spin from "antd/es/spin";
import Drawer from "antd/es/drawer";
import Popconfirm from "antd/es/popconfirm";
import {
  PhoneFilled,
  AudioMutedOutlined,
  AudioOutlined,
  VideoCameraOutlined,
  EyeInvisibleOutlined,
  RetweetOutlined,
  MessageOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import _ from "lodash";
import Participant from "./Participant";
import useIsMobile from "./utils/useIsMobile";
import Chat from "./components/Chat";
import ChatFooter from "./components/ChatFooter";

const Room = ({
  room,
  response,
  handleLogout,
  audioStatus,
  videoStatus,
  handleAudio,
  handleVideo,
}) => {
  const isMobile = useIsMobile();
  const [participants, setParticipants] = useState([]);
  const [cameras, setCameras] = useState([]);
  const [camera, setCamera] = useState(1);
  const [loading, setLoading] = useState(false);
  const [roomChat, setRoomChat] = useState(true);
  const [openDrawerChat, setOpenDrawerChat] = useState(false);

  useEffect(() => {
    const participantConnected = (participant) => {
      setParticipants((prevParticipants) =>
        _.uniqBy([...prevParticipants, participant], "sid")
      );
    };

    const participantDisconnected = (participant) => {
      setParticipants((prevParticipants) =>
        prevParticipants.filter((p) => p !== participant)
      );
    };

    room.on("participantConnected", participantConnected);
    room.on("participantDisconnected", participantDisconnected);
    room.participants.forEach(participantConnected);
    return () => {
      room.off("participantConnected", participantConnected);
      room.off("participantDisconnected", participantDisconnected);
    };
  }, [room]);

  function gotDevices(mediaDevices) {
    setCameras(mediaDevices);
  }

  useEffect(() => {
    navigator.mediaDevices.enumerateDevices().then(gotDevices);
  }, []);

  const localRoom = (
    <div
      className="room"
      style={{
        height: "100%",
        padding: 10,
      }}
    >
      {/* <PerfectScrollbar> */}
      <div
        style={{
          width: "100%",
          height: window.innerHeight - 20,
          borderRadius: 8,
          position: "relative",
          overflowX: "hidden",
          overflowY: "hidden",
        }}
        id="room-wrap"
      >
        <Row gutter={[12, 12]} style={{ height: "100%" }} justify="center">
          <Col
            xs={
              participants.length === 1
                ? 24
                : Math.ceil(24 / participants.length + 2)
            }
            sm={
              participants.length === 1
                ? 24
                : Math.ceil(24 / participants.length + 2)
            }
            md={
              participants.length === 1
                ? 24
                : Math.ceil(24 / participants.length + 2)
            }
            lg={
              participants.length === 1
                ? 12
                : Math.ceil(24 / participants.length + 2)
            }
            xl={
              participants.length === 1
                ? 12
                : Math.ceil(24 / participants.length + 2)
            }
            style={{
              height: isMobile
                ? participants.length > 0
                  ? "50%"
                  : "100%"
                : participants.length > 1
                ? "47%"
                : "100%",
            }}
          >
            {cameras.length > 0 ? (
              <Participant
                key={room.localParticipant.sid}
                participant={room.localParticipant}
                localParticipant={true}
                camera={camera}
                cameras={cameras}
                setCamera={setCamera}
              />
            ) : null}
          </Col>

          {participants.length > 0
            ? participants.map((participant) => (
                <Col
                  key={participant.sid}
                  xs={
                    participants.length === 1
                      ? 24
                      : Math.ceil(24 / participants.length + 2)
                  }
                  sm={
                    participants.length === 1
                      ? 24
                      : Math.ceil(24 / participants.length + 2)
                  }
                  md={
                    participants.length === 1
                      ? 24
                      : Math.ceil(24 / participants.length + 2)
                  }
                  lg={
                    participants.length === 1
                      ? 12
                      : Math.ceil(24 / participants.length + 2)
                  }
                  xl={
                    participants.length === 1
                      ? 12
                      : Math.ceil(24 / participants.length + 2)
                  }
                  style={{
                    height: isMobile
                      ? participants.length > 0
                        ? "50%"
                        : "100%"
                      : participants.length > 1
                      ? "47%"
                      : "100%",
                  }}
                >
                  <Participant
                    sm={24}
                    key={participant.sid}
                    participant={participant}
                  />
                </Col>
              ))
            : null}
        </Row>
        <div
          style={{
            position: "sticky",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bottom: 0,
            padding: 10,
            borderTopLeftRadius: 20,
            borderTopRightRadius: 20,
            borderBottomLeftRadius: 5,
            borderBottomRightRadius: 5,
            width: "100%",
          }}
        >
          <Button
            style={{
              background: "#434c54",
              backdropFilter: "blur(3px)",
              marginRight: 5,
              color: "#fff",
            }}
            type={audioStatus ? "text" : "danger"}
            danger={!audioStatus}
            icon={!audioStatus ? <AudioMutedOutlined /> : <AudioOutlined />}
            onClick={() => handleAudio()}
            shape="circle"
            size="large"
          ></Button>
          <Button
            type={videoStatus ? "text" : "primary"}
            danger={!videoStatus}
            icon={
              !videoStatus ? <EyeInvisibleOutlined /> : <VideoCameraOutlined />
            }
            onClick={() => handleVideo(videoStatus ? false : true)}
            shape="circle"
            size="large"
            style={{
              background: "#434c54",
              backdropFilter: "blur(3px)",
              marginRight: 5,
              color: "#fff",
            }}
          ></Button>
          <Popconfirm
            placement="top"
            title="Anda yakin menutup panggilan?"
            onConfirm={() => {
              handleLogout();
            }}
            okText="Iya"
            cancelText="Tidak"
            key="logout"
          >
            <Button
              danger
              type="primary"
              icon={<PhoneFilled style={{ transform: "rotate(225deg)" }} />}
              size="large"
              style={{ marginRight: 5 }}
            ></Button>
          </Popconfirm>
          <Button
            type={camera === 1 ? "text" : "primary"}
            danger={camera === 2}
            icon={<RetweetOutlined />}
            onClick={() => setCamera(camera === 1 ? 2 : 1)}
            shape="circle"
            size="large"
            style={{
              background: "#434c54",
              backdropFilter: "blur(3px)",
              marginRight: 5,
              color: "#fff",
            }}
          ></Button>
          <Button
            type={"text"}
            icon={<MessageOutlined />}
            onClick={() => {
              if (isMobile) {
                setOpenDrawerChat(true);
              } else {
                if (roomChat) {
                  setRoomChat(false);
                } else {
                  setRoomChat(true);
                }
              }
            }}
            shape="circle"
            size="large"
            style={{
              background: "#434c54",
              backdropFilter: "blur(3px)",
              marginRight: 5,
              color: "#fff",
            }}
          ></Button>
        </div>
      </div>
      {/* </PerfectScrollbar> */}
    </div>
  );

  const cardChat = (height) => (
    <Card
      style={{
        background: window.THEMES.chatRoom,
        border: "unset",
        height: height,
        borderRadius: height === "100%" ? "unset" : "",
      }}
      bordered
      bodyStyle={{
        padding: 0,
        height: "100%",
        borderRadius: height === "100%" ? "unset" : "",
      }}
    >
      <Spin spinning={loading} tip="Sedang memproses..." className="h-full">
        {height === "100%" ? (
          <div style={{ display: "flex", alignItems: "center" }}>
            <div
              style={{
                color: "var(--ant-box-text-color)",
                fontWeight: "bold",
                fontSize: 14,
                padding: "10px 20px 10px 20px",
                height: "5%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              Pesan dalam panggilan
            </div>
            <div style={{ marginLeft: "auto", marginRight: 10 }}>
              <Button
                type="text"
                icon={<CloseOutlined className="footer-icon-color" />}
                onClick={() => setOpenDrawerChat(false)}
              />
            </div>
          </div>
        ) : (
          <div
            style={{
              color: "var(--ant-box-text-color)",
              fontWeight: "bold",
              fontSize: 14,
              padding: "10px 20px 10px 20px",
              height: "5%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            Pesan dalam panggilan
          </div>
        )}

        <div style={{ height: "75%" }}>
          <Chat room={room} setLoading={setLoading} />
        </div>
        <div
          style={{
            height: "15%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <ChatFooter
            room={room}
            response={response}
            setLoading={setLoading}
            loading={loading}
          />
        </div>
      </Spin>
    </Card>
  );

  return (
    <div
      style={{
        minHeight: "100%",
        minWidth: "100%",
        // background: window.THEMES.bgColor,
      }}
    >
      <Row
        //gutter={[12, 12]}
        style={{ height: "100%" }}
        justify="center"
        align={"middle"}
      >
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={roomChat ? 18 : 24}
          xl={roomChat ? 18 : 24}
          style={{ height: "100%" }}
        >
          {localRoom}
        </Col>
        <Col
          xs={0}
          sm={0}
          md={0}
          lg={roomChat ? 6 : 0}
          xl={roomChat ? 6 : 0}
          style={{ padding: 10 }}
        >
          {cardChat(window.innerHeight - 20)}
        </Col>
      </Row>
      <Drawer
        width={"100%"}
        bodyStyle={{ background: "transparent", padding: 0 }}
        closable={false}
        placement="left"
        // onClose={() => setOpenDrawerChat(false)}
        open={openDrawerChat}
      >
        {cardChat("100%")}
      </Drawer>
    </div>
  );
};

export default Room;
